module.exports = __webpack_public_path__ + "img/skull_14.3d5e8ac5.png";